import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PendingProvider } from './context/PendingContext';
import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Sites from './pages/Sites';
import Transfers from './pages/Transfers';
import Company from './pages/Company';
import Users from './pages/User';
import Sales from './pages/Sales';
import "./App.css";

function App() {
  return (
    <Router>
      <PendingProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route path="/products" element={<Products />} />
          <Route path="/sites" element={<Sites />} />
          <Route path="/transfers" element={<Transfers />} />
          <Route path="/companies" element={<Company />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/users" element={<Users />} />
        </Routes>
      </PendingProvider>
    </Router>
  );
}

export default App;
